import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { motion } from "framer-motion";
import { Footer } from "./Footer.jsx";
import { Header } from "./Header.jsx";
import { ScrollProgress } from "./ScrollProgress.jsx";
import { SiteEffects } from "./SiteEffects.jsx";

export function Layout() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);
  return <><ScrollProgress /><SiteEffects routeKey={location.pathname} /><Header /><motion.main key={location.pathname} initial={{ opacity: 0, y: 16, rotateX: -1.4, filter: "blur(5px)" }} animate={{ opacity: 1, y: 0, rotateX: 0, filter: "blur(0px)" }} transition={{ duration: .52, ease: [0.22, 1, 0.36, 1] }}><Outlet /></motion.main><Footer /></>;
}
